import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { SessionMainText } from 'domain/assistant/session-elements';
import { AssistantStoreType } from 'models/AssistantStore';
import { ASSISTANTS, getStepInfo } from 'utils/constants/assistant-steps';
import { HistoryProps } from 'utils/history';
import ExplanationScreen from '../ExplanationScreen';

const QuestionIntroScreen = inject('assistantStore')(
  observer(
    ({
      location,
      assistantStore: { currentAssistantType }
    }: { assistantStore: AssistantStoreType } & HistoryProps) => {
      const stepInfo = getStepInfo('step1_3', currentAssistantType);

      return (
        <ExplanationScreen
          progress={
            stepInfo?.progress || ASSISTANTS.creative_session.step1_3.progress
          }
          barProgress={stepInfo?.percent}
          sidebarHeadline={stepInfo?.header}
          header={<FormattedMessage id="assistant question intro header" />}
          headerStep={stepInfo?.header}
          videoId="hCgMr0M9gGY"
          videoPreview="/images/assistant/video/question_intro.png"
          timerSeconds={300}
          sidebarScrollTo="painpoint_question"
          showHeader="painpoint_question"
          location={location}
        >
          <SessionMainText>
            <FormattedMessage id="assistant question intro" />
          </SessionMainText>
        </ExplanationScreen>
      );
    }
  )
);

export default QuestionIntroScreen;
